export const LINK_PROTOCOLS = ['http', 'https', 'mailto', 'tel'] as const;

/**
 * Determine whether a link href uses an allowed URL scheme. Relative URLs and
 * fragments (no scheme) are permitted; when a scheme is present it must be in
 * the whitelist. The href is normalized first to defeat obfuscation such as
 * leading whitespace or control characters (e.g. "java\tscript:").
 */
export function isAllowedLinkHref(href: string): boolean {
  // oxlint-disable-next-line no-control-regex
  const normalized = href.replace(/[\s\u0000-\u001F]+/g, '').toLowerCase();
  const schemeMatch = normalized.match(/^([a-z][a-z0-9+.-]*):/);

  if (!schemeMatch) {
    return true;
  }

  return (LINK_PROTOCOLS as readonly string[]).includes(schemeMatch[1]);
}
